import { render, staticRenderFns } from "./CustomBezierBorderIcon.vue?vue&type=template&id=8659d078&"
import script from "./CustomBezierBorderIcon.vue?vue&type=script&lang=js&"
export * from "./CustomBezierBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports